export function getDomain(hostname = ''): string {
  let result = '';

  const localhost = 'localhost';
  const separator = '.';
  const start = hostname.indexOf(separator);
  const withoutPort = hostname.replace(/:\d+/, '');

  const isIpAddress =
    /^(?:0|[1-9]\d{0,2})(?:\.(?:0|[1-9]\d{0,2})){3}$/.test(withoutPort) &&
    withoutPort.split('.').every((octet) => Number(octet) <= 255);

  if (isIpAddress) {
    return withoutPort;
  }

  if (withoutPort.endsWith(localhost)) {
    const splitted = withoutPort.split('.');

    return splitted.at(-1) ?? '';
  }

  if (start !== -1) {
    const split = hostname.split(separator);

    result = withoutPort
      .split(separator)
      .slice(split.length - 2)
      .join(separator);
  }

  return result;
}
